// extracted by mini-css-extract-plugin
export default {"photoContainer":"PhotoViewerComponent_photoContainer__yelKc","onePhotoCard":"PhotoViewerComponent_onePhotoCard__kJrug"};